// extracted by mini-css-extract-plugin
export var icon = "InformationSlide-module--icon--c4f46";
export var info = "InformationSlide-module--info--aab34";
export var infoText = "InformationSlide-module--infoText--5a105";
export var slide = "InformationSlide-module--slide--a57f9";